module.exports = __webpack_public_path__ + "img/course-gray.svg";